import registrationApi from './registrationApi';

export const verifyEmailByCodeAndRegister = (verifyEmailAndRegisterApiProvider = registrationApi) => {
  return async (
    code,
    registrationUrl,
    setErrorType,
    setStep,
  ) => {
    try {
      const { status, error, data } = await verifyEmailAndRegisterApiProvider(
        registrationUrl,
        { emailCode: code, emailUrlToken: '' },
      );

      if (status === 200) {
        setStep('SUCCESS');
        if (data?.redirectUrl) {
          return window.location.assign(data.redirectUrl);
        }
      } else if (error?.type) {
        setErrorType(error.type || null);
      }
    } catch (error) {
      console.error(error)
    }
  };
};

export default verifyEmailByCodeAndRegister(registrationApi);
